import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  desktopColumn: {
    flex: 1,
    justifyContent: 'space-between',
    gap: theme.spacing[9],
  },
  mobileColumn: {
    gap: theme.spacing[5],
  },
  // Closed-only: fills StandbyClosedScreen's flex:1 branding column so
  // closedNameBlockRow below has room to center in.
  mobileColumnClosed: {
    flex: 1,
  },
  mobileTopRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  // Closed-only: fills the space between the top row and the pinned-bottom
  // CTA; two closedSpacer children center the name block within it.
  closedNameBlockRow: {
    flex: 1,
  },
  // Empty grow spacer: two of these above and below the name block center it
  // vertically without `justifyContent`, which unistyles drops on a flex
  // container on web.
  closedSpacer: {
    flex: 1,
  },
  // Closed-only: Figma's 56x56 plate with Radius/m (16), replacing Avatar's
  // size="lg" (64) + shape="square" radius (12).
  closedLogo: {
    width: theme.spacing[11],
    height: theme.spacing[11],
    borderRadius: theme.borderRadius.m,
  },
  desktopMiddle: {
    gap: theme.spacing[6],
    alignItems: 'flex-start',
  },
  nameBlock: {
    gap: theme.spacing[4],
  },
  addressRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[3],
  },
  // Row children don't shrink by default — without this, a long address
  // overflows the branding column on narrow screens instead of wrapping.
  address: {
    flexShrink: 1,
  },
  // "Powered by" sits above the wordmark, both left-aligned. `width: 'auto'`
  // keeps the lockup content-sized next to the logo in the mobile row, the
  // repo's convention for a row child (see AppointmentDetailSummary's
  // promoLabelContainer).
  poweredByLockup: {
    alignItems: 'flex-start',
    gap: theme.spacing[2],
    width: 'auto',
  },
});
